import React, { useContext } from 'react'
import { Box, Typography, Grid, TextField } from '@mui/material'
import {Controller, useFormContext} from 'react-hook-form'
import { WhatsappDataContext } from '../WhatsappMessageContent';

const TemplateContent = () => {
    const { selectedTemplate, templateVariables,} = useContext(WhatsappDataContext);
    const { control } = useFormContext();
  return (
    <>
        {selectedTemplate && (
            <>
                {/* Dynamic Parameter Fields */}
                {templateVariables.length > 0 && (
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, fontSize: '0.8rem' }}>
                            Template Parameters
                        </Typography>
                        <Grid container spacing={2}>
                            {templateVariables.map((variable, index) => (
                                <Grid item xs={4} key={variable.key}>
                                    <Controller
                                        name={`whatsappTemplateParams.${variable.key}`}
                                        control={control}
                                        rules={{ required: `${variable.label} is required` }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label={variable.label}
                                                size="small"
                                                InputProps={{
                                                    style: { fontSize: '0.8rem' }
                                                }}
                                                InputLabelProps={{
                                                    style: { fontSize: '0.8rem' }       
                                                }}
                                                error={!!error}
                                                helperText={error ? error.message : (variable.example ? `Example: ${variable.example}` : '')}
                                            />
                                        )}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}
            </>
        )}
    </>
  )
}

export default TemplateContent
